import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      position="top-right"
      closeButton
      richColors
      toastOptions={{
        classNames: {
          toast: 
            "group toast group-[.toaster]:bg-slate-800 group-[.toaster]:text-white group-[.toaster]:border-slate-600 group-[.toaster]:shadow-xl",
          title: "group-[.toast]:text-white group-[.toast]:font-medium",
          description: "group-[.toast]:text-slate-300",
          actionButton: 
            "group-[.toast]:bg-cyan-500 group-[.toast]:text-white",
          cancelButton: 
            "group-[.toast]:bg-slate-700 group-[.toast]:text-slate-200",
          closeButton: 
            "group-[.toaster]:bg-slate-700 group-[.toaster]:border-slate-600 group-[.toaster]:text-white",
          success: "group-[.toaster]:bg-emerald-900 group-[.toaster]:text-emerald-100 group-[.toaster]:border-emerald-700",
          error: "group-[.toaster]:bg-red-900 group-[.toaster]:text-red-100 group-[.toaster]:border-red-700",
          warning: "group-[.toaster]:bg-amber-900 group-[.toaster]:text-amber-100 group-[.toaster]:border-amber-700",
          info: "group-[.toaster]:bg-blue-900 group-[.toaster]:text-blue-100 group-[.toaster]:border-blue-700",
        },
      }}
      {...props} 
    />
  );
}

export { Toaster, toast }
